import React, {useEffect} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import Text from 'components/Text';
import Panel from 'components/Panel';

import AuthPageWrapper from './shared/AuthPageWrapper';

import {LogoPanel} from './login';

function LoginHelpPage() {
	const {t, i18n} = useTranslation();
	const navigate = useNavigate();

	useEffect(() => {
		if (!i18n.exists('login_help_message')) {
			navigate('/login', {state: {wasRedirected: true}});
		}
	}, [navigate, i18n]);

	return (
		<AuthPageWrapper>
			<LogoPanel />
			<Panel>
				<PageTitle visuallyHidden>{t('login_help')}</PageTitle>
				<Text as="p">{t('login_help_message')}</Text>
			</Panel>
			<Panel align="right">
				<Button
					as={Link}
					to="/login"
					id="back"
					variant="transparent"
					size="small"
					mt="xs"
					mr="-xs"
				>
					{t('actions_go_back')}
				</Button>
			</Panel>
		</AuthPageWrapper>
	);
}

export default LoginHelpPage;
